import $ from "jquery";

function Carousel() {
	document.addEventListener("DOMContentLoaded", this._init.bind(this));
}

Carousel.prototype._init = function () {
	$(".slider-wrapper").each(function () {

		var $slider = $(this).find('.slider');
		var $next = $(this).find('.next');
		var $back = $(this).find('.back');

		var totalSlides = $slider.find('.slider__item').length;

		var $scrubebr = $(this).find('.slider-controls__scrubber');
		var $track = $(this).find('.scrubber-track');
		var $bar = $(this).find('.scrubber-bar');

		var $counter = $(this).find('.slider-controls__counter');

        $slider.slick({
            arrows: false,
            infinite: false,
            speed: 1000,
            cssEase: 'ease'
		});

        $next.on('click', function () {
            $slider.slick('slickNext');
        });

        $back.on('click', function () {
            $slider.slick('slickPrev');
        });

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var count = nextSlide + 1;
            $counter.html( count + '/' + slick.slideCount );
            $bar.css({
				'left': calc(slick.slideCount, nextSlide)
            });
        });

        var calc = function (total, current) {
        	var total = total - 1;

            var trackLength = $track.width();
			var part = Math.floor(trackLength / total);

			return (( 100 / trackLength ) * (part * current)) + '%';
        }

	})
}

module.exports = new Carousel();


// WEBPACK FOOTER //
// ./source/assets/scripts/carousels.js